import React from "react"
import { connect } from 'react-redux'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

// core components
import GridContainer from "components/GridContainer"
import GridItem from "components/GridItem"
import Card from "components/Card"
import CardBody from "components/CardBody"
import CardHeader from "components/CardHeader"

import extendedTablesStyle from "./extendedTablesStyle.jsx"

import { primaryColor } from "../../assets/jss/material-dashboard-pro-react";
import { mapService } from "../../_services";

import ReactTable from "../../components/react-table";
import Button from "../../components/CustomButtons";
import { sweetAlertActions } from "../../_actions";
import CustomInput from "../../components/CustomInput";
import { update_location_list } from "../helper_functions/locations";
import ClipboardButton from "../../components/ClipboardButoon";
import MyDropdown from "../../components/MyDropdown";
import Table from "../../components/Table";
import { getUserType } from "../../_services/authenticate";

class Locations extends React.Component {
  requiredFields = ["name", "address", "owned_by", "timezone"];
  constructor(props) {
    super(props)
    this.state = {
      totalResults: 0,
      totalPages: 0,
      pageSize: 10,
      currentPage: 1,
      show_deactivated: false,
      loading: false,
      updated_properties: {},
      data: [],
      number_greenhouses: {},
      create_location: false,
      update_location: null,
      timezones: [],
      field_errors: {}
    }

    this.timer = null
    this._is_mounted = false
  }

  componentDidMount() {
    this._is_mounted = true
    mapService.getTimezones(result => {
      this.setState({ timezones: result.timezones.sort() })
    })
    this.refresh()
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    this._is_mounted = false
  }

  refresh() {
    const {currentPage, pageSize, show_deactivated} = this.state
    this.setState({loading: true})

    mapService.getLocations(pageSize, currentPage - 1, show_deactivated, result => {
      const total_pages = Math.ceil(result.total / pageSize)
      let newCurrentPage = currentPage
      if (currentPage > total_pages && result.total > 0) {
        newCurrentPage = total_pages
      }

      result.results.forEach((location) => {
        mapService.getGreenhousesForLocation(location["id"], res => {
          let { number_greenhouses } = this.state
          number_greenhouses[location["id"]] = res.greenhouses.length
          this.setState({ number_greenhouses })
        })
      })

      this.setState({
        totalResults: result.total,
        currentPage: newCurrentPage,
        data: result.results,
        totalPages: total_pages,
        loading: false,
      })
    }, error => {
      this.setState({
        data: [],
        totalPages: 0,
        loading: false
      })
    });
  }

  change_value(value_name, value) {
    let { updated_properties, field_errors } = this.state;
    updated_properties[value_name] = value;
    // Validate the field immediately
    if (this.requiredFields.includes(value_name) && (!value || value.toString().trim() === "")) {
      field_errors[value_name] = `${this.getFieldLabel(value_name)} is required.`;
    } else {
      delete field_errors[value_name];
    }
    this.setState({ updated_properties, field_errors });
  }

  getFieldLabel(field) {
    // Map field names to user-friendly labels
    switch (field) {
      case "name": return "Name";
      case "address": return "Address";
      case "owned_by": return "Owned By";
      case "timezone": return "Timezone";
      default: return field.charAt(0).toUpperCase() + field.slice(1);
    }
  }

  toggle_show_deactivated() {
    const {show_deactivated} = this.state
    this.setState({show_deactivated: !show_deactivated }, () => this.refresh());
  }

  start_creating_location() {
    // Validate all fields on form open so errors show immediately
    const errors = this.validate_new_location_fields(this.state.updated_properties);
    this.setState({ create_location: true, field_errors: errors });
  }

  start_updating_location(location) {
    this.setState({ update_location: location })
  }

  deactivate_location(location) {
    const {dispatch} = this.props;
    mapService.updateLocation(location.id, null, null, null, null, null, true,res => {
      dispatch(sweetAlertActions.success({title: "Location is deactivated"}))
      update_location_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error deactivating ${location.name}.`, content: "Verify that all greenhouses for this location have been deactivated." }))
      })
  }

  activate_location(location) {
    const {dispatch} = this.props;
    mapService.updateLocation(location.id, null, null, null, null,  null,false,res => {
      dispatch(sweetAlertActions.success({title: "Location is activated"}))
      update_location_list()
      this.refresh()
    }, error => {
      dispatch(sweetAlertActions.danger({ title: `Error activating ${location.name}.` }))
    })
  }

  start_deactivating_location(location) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.deactivate_location.bind(this, location),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will deactivate <b>{location.name}</b></h5>
        <p>Only a Nimbus System Admin can reverse this.</p>
        <br/>
        <p><b>ID:</b>{location.id}</p>
        <p><b>Organisation ID:</b>{location.owned_by}</p>
      </div>
    }))
  }

  start_activating_location(location) {
    const {dispatch} = this.props;
    dispatch(sweetAlertActions.clean({
      title: "Are you sure?",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.activate_location.bind(this, location),
      confirmBtnText: "Yes",
      content: <div>
        <h5>You will activate <b>{location.name}</b></h5>
        <br/>
        <p><b>ID:</b>{location.id}</p>
        <p><b>Organisation ID:</b>{location.owned_by}</p>
      </div>
    }))
  }

  do_update_location(location) {
    const { updated_properties } = this.state
    const { dispatch } = this.props;

    let new_name = undefined
    if (updated_properties["name"] !== undefined) {
      if (updated_properties["name"] !== location["name"]) {
        new_name = updated_properties["name"]
      }
    }

    let new_client_name = undefined
    if (updated_properties["client_name"] !== undefined) {
      if (updated_properties["client_name"] !== location["client_name"]) {
        new_client_name = updated_properties["client_name"]
      }
    }

    let new_owner = undefined
    if (updated_properties["owned_by"] !== undefined) {
      if (updated_properties["owned_by"] !== location["owned_by"]) {
        new_owner = updated_properties["owned_by"]
      }
    }

    let new_timezone = undefined
    if (updated_properties["timezone"] !== undefined) {
      if (updated_properties["timezone"] !== location["timezone"]) {
        new_timezone = updated_properties["timezone"]
      }
    }

    let new_address = undefined
    if (updated_properties["address"] !== undefined) {
      if (updated_properties["address"] !== location["address"]) {
        new_address = updated_properties["address"]
      }
    }

    mapService.updateLocation(location["id"], new_name, new_client_name, new_owner, new_address, new_timezone, null,res => {
      dispatch(sweetAlertActions.clear())
      update_location_list()
      this.setState({
        updated_properties: {},
        update_location: null
      }, () => this.refresh())
    }, error => {
      dispatch(sweetAlertActions.danger({ title: "Error updating the location" }))
    })
  }
  validate_new_location_fields(properties) {
    const errors = {};
    this.requiredFields.forEach(field => {
      if (!properties[field] || properties[field].toString().trim() === "") {
        errors[field] = `${this.getFieldLabel(field)} is required.`;
      }
    });
    return errors;
  }

  create_new_location() {
    const { updated_properties } = this.state;
    const { dispatch } = this.props;
    const errors = this.validate_new_location_fields(updated_properties);
    if (Object.keys(errors).length > 0) {
      this.setState({ field_errors: errors });
      dispatch(sweetAlertActions.danger({ title: "Missing Fields", content: <div>{Object.values(errors).map((msg, i) => <div key={i}>{msg}</div>)}</div> }));
      return;
    }
    mapService.createLocation(updated_properties["name"], updated_properties["address"], updated_properties["owned_by"], updated_properties["timezone"], res => {
      dispatch(sweetAlertActions.success({ title: "Location is created" }))
      update_location_list()
      this.setState({
        updated_properties: {},
        create_location: false,
        field_errors: {}
      }, () => this.refresh())
    })
  }

  get_network_information(location_id) {
    const { dispatch } = this.props
    mapService.getNetworkInformation(location_id, res => {
      if (res === null) {
        dispatch(sweetAlertActions.warning({
          title: "No network information found"
        }))
      } else {
        dispatch(sweetAlertActions.success({
          title: "Network Information - decrypted",
          content: <div>
            <p>This request was logged</p>
            <p><b>WiFi SSID: </b> {res.wifi_ssid}</p>
            <p><b>WiFi Password: </b> {res.wifi_password}</p>
          </div>
        }))
      }
    })
  }

  start_update_network_information(location_id) {
    const { dispatch } = this.props
    const { updated_properties } = this.state

    dispatch(sweetAlertActions.clean({
      title: "Update Network Information",
      showCancel: true,
      onCancel: this.clear_popup.bind(this),
      cancelBtnText: "No",
      onConfirm: this.update_network_information.bind(this, location_id),
      confirmBtnText: "Yes",
      content: <div>
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"wifi_ssid"}
          labelText={"WiFi SSID"}
          inputProps={{
            onChange: event => this.change_value("wifi_ssid", event.target.value),
            type: "text",
            value: updated_properties["wifi_ssid"]
          }}
        />
        <CustomInput
          style={{
            fullWidth: true,
            width: "100%"
          }}
          id={"wifi_password"}
          labelText={"WiFi Password"}
          inputProps={{
            onChange: event => this.change_value("wifi_password", event.target.value),
            type: "text",
            value: updated_properties["wifi_password"]
          }}
        />
      </div>
    }))
  }

  update_network_information(location_id) {
    const { updated_properties } = this.state
    const { dispatch } = this.props;

    mapService.updateNetworkInformation(location_id, updated_properties["wifi_ssid"], updated_properties["wifi_password"], res => {
      dispatch(sweetAlertActions.clear())
      this.setState({
        updated_properties: {}
      }, () => this.refresh())
    })
  }


  clear_popup() {
    const { dispatch } = this.props;
    dispatch(sweetAlertActions.clear())
    this.setState({
      updated_properties: {}
    }, () => this.refresh())
  }

  render() {
    const { organisations } = this.props
    const {
      currentPage,
      data,
      pageSize,
      loading,
      totalResults,
      totalPages,
      number_greenhouses,
      updated_properties,
      update_location,
      create_location,
      timezones,
      field_errors,
      show_deactivated
    } = this.state

    let filler_size = (currentPage - 1) * pageSize
    if (filler_size < 0) {
      filler_size = 0
    }
    let filler_array = Array(filler_size).keys()

    let columns = [
      {
        Header: "ID",
        accessor: "id",
        filterable: false,
        sortable: false,
        maxWidth: 50,
        Cell: row => {
          return <ClipboardButton text={row.value} />
        }
      },
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Client Name",
        accessor: "client_name",
      },
      {
        Header: "Owned By",
        accessor: "owned_by",
        Cell: row => {
          if (organisations[row.value]) {
            return organisations[row.value].name
          }
          return row.value
        }
      },
      {
        Header: "Timezone",
        accessor: "timezone",
      },
    ]

    columns.push(...[
      {
        Header: "Address",
        accessor: "address",
      },
      {
        Header: "# Greenhouses",
        accessor: "id",
        Cell: row => {
          return number_greenhouses[row.value]
        }
      },
      {
        Header: "Update Location",
        accessor: "id",
        Cell: row => {
          return <>
            {row.original.deactivated ?
              <>
                {getUserType() === "system_admin" ?
                  <Button
                    color="warning"
                    simple
                    onClick={this.start_activating_location.bind(this, row.original)}
                  >
                    <b>{"Activate"}</b>
                  </Button> :
                  <p>Contact your Nimbus System Manager to activate again.</p>
                }
              </>:
              <>
                <Button
                  color="primary"
                  simple
                  onClick={this.start_updating_location.bind(this, row.original)}
                >
                  <b>{"Update"}</b>
                </Button>
                <Button
                  color="danger"
                  simple
                  onClick={this.start_deactivating_location.bind(this, row.original)}
                >
                  <b>{"Deactivate"}</b>
                </Button>
              </>
            }
          </>
        }
      },
      {
        Header: "Network Information",
        accessor: "id",
        Cell: row => {
          return <div>
            <Button color={"primary"} simple
              onClick={this.get_network_information.bind(this, row.value)}><b>{"Get Info"}</b></Button>
            <Button color={"warning"} simple
              onClick={this.start_update_network_information.bind(this, row.value)}><b>{"Update Info"}</b></Button>
          </div>
        }
      }
    ])

    return (
      <GridContainer>
        {create_location &&
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <GridContainer>
                  <GridItem xs={10}>
                    <h4 style={{ color: primaryColor }}><b>{"Create Location"}</b></h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <div>
                  <CustomInput
                    style={{
                      fullWidth: true,
                      width: "100%"
                    }}
                    id={"name"}
                    labelText={"Name"}
                    inputProps={{
                      onChange: event => this.change_value("name", event.target.value),
                      type: "text",
                      value: updated_properties["name"]
                    }}
                  />
                  {field_errors["name"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["name"]}</div>}
                  <CustomInput
                    style={{
                      fullWidth: true,
                      width: "100%"
                    }}
                    id={"client_name"}
                    labelText={"Client Name"}
                    inputProps={{
                      onChange: event => this.change_value("client_name", event.target.value),
                      type: "text",
                      value: updated_properties["client_name"]
                    }}
                  />
                  {field_errors["client_name"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["client_name"]}</div>}

                  <MyDropdown
                    input_label={"Owned By"}
                    name={"owned_by"}
                    value={updated_properties["owned_by"]}
                    handle_selection={
                      this.change_value.bind(this)
                    }
                    options={[
                      ...Object.keys(organisations).sort((a, b) => {
                        return organisations[a]["name"] < organisations[b]["name"] ? -1 : 1
                      }).map((organisation_id) => {
                        return {
                          id: organisation_id,
                          value: organisations[organisation_id]["name"]
                        }
                      })
                    ]}
                  />
                  {field_errors["owned_by"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["owned_by"]}</div>}
                  <MyDropdown
                    input_label={"Timezone"}
                    name={"timezone"}
                    value={updated_properties["timezone"]}
                    handle_selection={
                      this.change_value.bind(this)
                    }
                    options={[
                      ...timezones.map((tz) => {
                        return {
                          id: tz,
                          value: tz
                        }
                      })
                    ]}
                  />
                  {field_errors["timezone"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["timezone"]}</div>}
                  <CustomInput
                    style={{
                      fullWidth: true,
                      width: "100%"
                    }}
                    id={"address"}
                    labelText={"Address"}
                    inputProps={{
                      onChange: event => this.change_value("address", event.target.value),
                      type: "text",
                      value: updated_properties["address"]
                    }}
                  />
                  {field_errors["address"] && <div style={{ color: 'red', fontSize: 12, marginTop: 2 }}>{field_errors["address"]}</div>}
                </div>
                <Button simple color={"primary"} onClick={this.create_new_location.bind(this)}> Create </Button>
                <Button simple color={"danger"} onClick={() => {
                  this.setState({ create_location: false, updated_properties: {} })
                }}> Cancel </Button>
              </CardBody>
            </Card>
          </GridItem>
        }
        {update_location &&
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <GridContainer>
                  <GridItem xs={10}>
                    <h4 style={{ color: primaryColor }}><b>{"Update Location"}</b></h4>
                  </GridItem>
                </GridContainer>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12}>
                    <p><b>Leave empty if you do not want to update the property</b></p>
                  </GridItem>
                  <GridItem xs={12}>
                    <Table
                      tableData={[
                        [
                          <p><b>Name:</b> {update_location["name"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"name"}
                            labelText={"New name"}
                            inputProps={{
                              onChange: event => this.change_value("name", event.target.value),
                              type: "text",
                              value: updated_properties["name"]
                            }}
                          />
                        ],
                        [
                          <p><b>Client Name:</b> {update_location["client_name"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"client_name"}
                            labelText={"New client name"}
                            inputProps={{
                              onChange: event => this.change_value("client_name", event.target.value),
                              type: "text",
                              value: updated_properties["client_name"]
                            }}
                          />
                        ],
                        [
                          <p><b>Address:</b> {update_location["address"]}</p>,
                          <CustomInput
                            style={{
                              fullWidth: true,
                              width: "100%"
                            }}
                            id={"address"}
                            labelText={"New address"}
                            inputProps={{
                              onChange: event => this.change_value("address", event.target.value),
                              type: "text",
                              value: updated_properties["address"]
                            }}
                          />],
                        [
                          <p><b>Timezone:</b> {update_location["timezone"]}</p>,
                          <MyDropdown
                            input_label={"Timezone"}
                            name={"timezone"}
                            value={updated_properties["timezone"]}
                            handle_selection={
                              this.change_value.bind(this)
                            }
                            options={[
                              ...timezones.map((tz) => {
                                return {
                                  id: tz,
                                  value: tz
                                }
                              })
                            ]}
                          />
                        ],
                        [
                          <p>
                            <b>Owner:</b>
                            {organisations[update_location["owned_by"]] ?
                              organisations[update_location["owned_by"]]["name"] : update_location["owned_by"]
                            }
                            {getUserType() === "system_admin" &&
                              <p><b>Owner ID:</b> {update_location["owned_by"]}</p>
                            }
                          </p>,
                          getUserType() === "system_admin" ?
                            <CustomInput
                              style={{
                                fullWidth: true,
                                width: "100%"
                              }}
                              id={"owned_by"}
                              labelText={"New Owner"}
                              inputProps={{
                                onChange: event => this.change_value("owned_by", event.target.value),
                                type: "text",
                                value: updated_properties["owned_by"]
                              }}
                            />
                            :
                            <p>Can only be updated by your Cloud Manager</p>
                        ],
                        ["", ""],
                      ]}
                    />
                  </GridItem>
                  <GridItem xs={12}>
                    <Button simple color={"primary"}
                      onClick={this.do_update_location.bind(this, update_location)}> Update </Button>
                    <Button
                      simple
                      color={"danger"}
                      onClick={() => {
                        this.setState({ update_location: null, updated_properties: {} })
                      }}
                    >
                      Cancel
                    </Button>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        }
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader>
              <GridContainer>
                <GridItem xs={6}>
                  <h4 style={{color: primaryColor}}><b>{"Overview Locations"}</b></h4>
                </GridItem>
                <GridItem xs={6} style={{textAlign: "right", justifyContent: "right"}}>
                  <Button color="primary" simple
                          onClick={this.toggle_show_deactivated.bind(this)}><b>{show_deactivated ? "Hide deactivated": "Show Deactivated"}</b></Button>
                  <Button color="primary" simple
                    onClick={this.start_creating_location.bind(this)}><b>{"Create Location"}</b></Button>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <h5># Results: {totalResults}</h5>
              <ReactTable
                columns={columns}
                data={[
                  ...filler_array,
                  ...data
                ]}
                sortable={false}
                filterable={false}
                loading={loading}
                pages={totalPages}
                page={currentPage - 1}
                pageSize={pageSize}
                onPageChange={(pageIndex) => this.setState({ currentPage: pageIndex + 1 }, () => this.refresh())}
                onPageSizeChange={(newPageSize) => {
                  this.setState({ currentPage: 1, pageSize: newPageSize }, () => this.refresh())
                }}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )
  }
}


function mapStateToProps(state) {
  const { total_nr_organisations, organisations } = state.location
  return {
    total_nr_organisations, organisations
  }
}


export default withStyles(extendedTablesStyle)(connect(mapStateToProps)(Locations))
